import React from "react"
import { Box, IconWarn, Text } from "dash-styled"

interface Props {
    message: string
    className?: string
}

export const ErrorInstanceTag = ({ message, className }: Props) => (
    <Box
        display="flex"
        fullWidth={true}
        paddingLeft="3"
        paddingTop="2"
        paddingBottom="2"
        className={"bg-rhino-100 text-rhino-900 rounded-b " + className}
    >
        <IconWarn className="mr-1" size="xl" />
        <Text
            size="sm"
            color="currentColor"
            className="m-0 align-middle leading-6"
        >
            {message}
        </Text>
    </Box>
)
